export default {
  ND: 'ND',
  FD: 'FD',
  POTENTIAL: 'POTENTIAL',
  CUSTOM_ND: 'CUSTOM_ND',
  CUSTOM_FD: 'CUSTOM_FD',
  CUSTOM_POTENTIAL: 'CUSTOM_POTENTIAL',
};
